// Messages for the invoice line-items editor (auto-merged by lib/i18n.ts).
export const en = {
  'operator.invoice_lines.col.charge': 'Charge',
  'operator.invoice_lines.col.qty': 'Qty',
  'operator.invoice_lines.col.amount': 'Unit amount',
  'operator.invoice_lines.col.line_total': 'Line total',
  'operator.invoice_lines.desc_aria': 'Charge {n} description',
  'operator.invoice_lines.desc_placeholder': 'e.g. Ocean freight',
  'operator.invoice_lines.qty_aria': 'Charge {n} quantity',
  'operator.invoice_lines.amount_aria': 'Charge {n} unit amount',
  'operator.invoice_lines.remove_aria': 'Remove charge {n}',
  'operator.invoice_lines.add': 'Add charge',
  'operator.invoice_lines.subtotal': 'Subtotal',
  'operator.invoice_lines.tax': 'Tax ({rate}%)',
  'operator.invoice_lines.total': 'Total',
}

export const zhTW = {
  'operator.invoice_lines.col.charge': '費用項目',
  'operator.invoice_lines.col.qty': '數量',
  'operator.invoice_lines.col.amount': '單價',
  'operator.invoice_lines.col.line_total': '小計',
  'operator.invoice_lines.desc_aria': '費用 {n} 說明',
  'operator.invoice_lines.desc_placeholder': '例如：海運費',
  'operator.invoice_lines.qty_aria': '費用 {n} 數量',
  'operator.invoice_lines.amount_aria': '費用 {n} 單價',
  'operator.invoice_lines.remove_aria': '移除費用 {n}',
  'operator.invoice_lines.add': '新增費用',
  'operator.invoice_lines.subtotal': '小計',
  'operator.invoice_lines.tax': '稅金（{rate}%）',
  'operator.invoice_lines.total': '總計',
}
